import { createCrudSlice } from "./createCrudSlice";
import {
  GET_CUSTOMERS,
  GET_CUSTOMER_DETAILS,
  GET_CUSTOMER_VEHICLE_DETAILS,
  GET_CUSTOMER_TRANSACTIONS,
  GET_CUSTOMER_MEMBERSHIPS,
  UPDATE_CUSTOMER_STATUS,
  GET_CUSTOMERS_LIST,
  REFERRAL_HISTORY_LIST,
  LOYALTY_POINTS_HISTORY_LIST,
} from "helpers/url_helper";

const { reducer, actions, thunks } = createCrudSlice({
  name: "customers",

  urls: {
    getList: GET_CUSTOMERS,
    getDetails: GET_CUSTOMER_DETAILS,
    updateStatus: UPDATE_CUSTOMER_STATUS,
  },

  initialFilters: {
    keyword: "",
    referralCodeKeyword: "",
    customerVehiclesKeyword: "",
    loyaltyPointKeyword: "",
    membershipNumberKeyword: "",
    customerTransactionKeyword: "",
    status: -1,
    orderBy: -1,
    dates: [],
    pageNo: 1,
    perPage: 50,
    platform: "",
    source:"",
    type:"",
    used:false, // THIS IS REFERRAL CODE USAGE STATUS
    customerTransactionPaymentStatus :"",
    customerMembershipStatus :"",
  },

  additionalThunks: {
    getVehicleDetails: {
      type: "customers/getVehicleDetails",
      url: () => `${GET_CUSTOMER_VEHICLE_DETAILS}`,
      method: "post",
      stateKey: "vehicleDetails",
      loadingKey: "loading2",
    },
    getTransactions: {
      type: "customers/getTransactions",
      url: () => `${GET_CUSTOMER_TRANSACTIONS}`,
      method: "post",
      stateKey: "transactions",
      loadingKey: "loading2",
    },
    getMemberships: {
      type: "customers/getMemberships",
      url: () => `${GET_CUSTOMER_MEMBERSHIPS}`,
      method: "post",
      stateKey: "memberships",
      loadingKey: "loading2",
    },
    getCustomersList: {
      type: "customers/getCustomerDropdownList",
      url: (keyword) => `${GET_CUSTOMERS_LIST}?keyword=${keyword}`,
      method: "get",
      stateKey: "customersList",
    },
    getReferralHistory: {
      type: "customers/getReferralHistory",
      url: () => `${REFERRAL_HISTORY_LIST}`,
      method: "post",
      stateKey: "referralHistory",
      loadingKey: "loading2",
    },
    getLoyaltyPointsHistory: {
      type: "customers/getLoyaltyPointsHistory",
      url: () => `${LOYALTY_POINTS_HISTORY_LIST}`,
      method: "post",
      stateKey: "loyaltyPointsHistory",
      loadingKey: "loading2",
    },
  },

  initialState: {
    loading2: true,
    vehicleDetails: [],
    transactions: [],
    memberships: [],
    customersList: [],
    referralHistory: [],
    loyaltyPointsHistory: [],
  },
});

// Export actions
export const { setFilter, resetFilters, clearItemDetails } = actions;

// Export thunks
export const {
  getList: getCustomers,
  getDetails: getCustomerDetails,
  updateStatus: updateCustomerStatus,
  getVehicleDetails,
  getTransactions,
  getMemberships,
  getCustomersList,
  getReferralHistory,
  getLoyaltyPointsHistory,
} = thunks;

// Export reducer
export default reducer;
